
import { supabase } from "@/integrations/supabase/client";

export interface CandidateSearchResult {
  id: string;
  name: string;
  type: "candidate";
}

export async function searchCandidates(debouncedQuery: string, limit = 3): Promise<CandidateSearchResult[]> {
  if (!debouncedQuery || debouncedQuery.length < 2) return [];
  const { data: candidates, error } = await supabase
    .from("candidates")
    .select("id, first_name, last_name")
    .or(`first_name.ilike.%${debouncedQuery}%,last_name.ilike.%${debouncedQuery}%`)
    .limit(limit);

  if (error || !candidates) return [];
  return candidates.map((candidate) => ({
    id: candidate.id,
    name: `${candidate.first_name || ""} ${candidate.last_name || ""}`.trim(),
    type: "candidate" as const,
  }));
}
